import routes from '@/lib/routes';
import { IConnectedUser } from '@/lib/interface.ts';
import userStore from '@/store/userStore.ts';
import useSWRMutation from 'swr/mutation';
import { login } from '@/components/api/requests.ts';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

import { notifyInternalMessage } from '@/functions';
import { apiClient } from '@/components/api/apiClient.ts';
import { useInvalidateQueries } from '@/hooks';

export const useLogin = () => {
	const navigate = useNavigate();
	const setStoreUser = userStore(state => state.setStoreUser);
	const { invalidate } = useInvalidateQueries();

	return useSWRMutation(routes.api.login, login, {
		onSuccess: data => {
			const userData: IConnectedUser = jwtDecode(data.token);
			apiClient.setHeader('Authorization', `Bearer ${data.token}`);
			setStoreUser({
				_id: userData._id,
				name: data.name,
				token: data.token,
				root: userData.root,
				email: userData.email,
				permissions: userData.permissions
			});
			invalidate();
			navigate(routes.nav.home);
		},
		onError: notifyInternalMessage,
	});
};
